import { useMutation } from '@tanstack/react-query';
import { Eye, X } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../hooks/useAuth';

export default function ImpersonationBanner() {
  const { user, impersonator, refreshAll } = useAuth();

  const stop = useMutation({
    mutationFn: () => api.delete('/admin/impersonate'),
    onSuccess: () => refreshAll(),
  });

  if (!impersonator || !user) return null;

  return (
    <div className="sticky top-0 z-40 flex items-center justify-between gap-3 border-b border-gold/40 bg-gold-soft px-4 py-2 text-sm">
      <div className="flex items-center gap-2 text-dark">
        <Eye className="h-4 w-4 text-gold" />
        <span>
          <span className="font-semibold">{impersonator.name}</span> zobrazuje aplikaci jako{' '}
          <span className="font-semibold">{user.name}</span>
          <span className="ml-1 text-xs uppercase tracking-wide text-gray-500">
            ({user.role}) · jen čtení
          </span>
        </span>
      </div>
      <button
        onClick={() => stop.mutate()}
        disabled={stop.isPending}
        className="flex items-center gap-1 rounded-md bg-dark px-3 py-1 text-xs font-bold uppercase tracking-wide text-white hover:bg-dark-soft disabled:opacity-60"
      >
        <X className="h-3 w-3" />
        {stop.isPending ? 'Ukončuji…' : 'Ukončit'}
      </button>
    </div>
  );
}
